/**
 * AksesKita - Default AAC Symbols (Bilingual: ID & EN)
 * Crisp, lightweight inline SVG symbols tailored for assistive communication.
 */

export const defaultCategories = [
  { id: 1, name: 'Kebutuhan', nameEn: 'Needs', icon: '🍽️', color: '#EA580C' },
  { id: 2, name: 'Respon', nameEn: 'Responses', icon: '💬', color: '#16A34A' },
  { id: 3, name: 'Perasaan', nameEn: 'Feelings', icon: '😊', color: '#2563EB' },
  { id: 4, name: 'Aktivitas & Orang', nameEn: 'Activities & People', icon: '👥', color: '#9333EA' }
];

export const defaultCards = [
  // 1. KEBUTUHAN (Category 1)
  {
    id: 101,
    categoryId: 1,
    label: 'Mau Makan',
    labelEn: 'Want Food',
    speechText: 'Saya mau makan',
    speechTextEn: 'I want to eat',
    iconEmoji: '🍚',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 102,
    categoryId: 1,
    label: 'Mau Minum',
    labelEn: 'Want Water',
    speechText: 'Saya mau minum air',
    speechTextEn: 'I want to drink water',
    iconEmoji: '🥛',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 103,
    categoryId: 1,
    label: 'Ke Toilet',
    labelEn: 'Restroom',
    speechText: 'Saya ingin pergi ke toilet',
    speechTextEn: 'I need to go to the restroom',
    iconEmoji: '🚻',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 104,
    categoryId: 1,
    label: 'Tolong',
    labelEn: 'Help',
    speechText: 'Tolong bantu saya',
    speechTextEn: 'Please help me',
    iconEmoji: '🆘',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 105,
    categoryId: 1,
    label: 'Istirahat',
    labelEn: 'Rest',
    speechText: 'Saya mau istirahat',
    speechTextEn: 'I want to take a rest',
    iconEmoji: '🛋️',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 106,
    categoryId: 1,
    label: 'Sakit',
    labelEn: 'Pain / Hurt',
    speechText: 'Badan saya terasa sakit',
    speechTextEn: 'I am in pain or feeling sick',
    iconEmoji: '🩹',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 107,
    categoryId: 1,
    label: 'Tidur',
    labelEn: 'Sleep',
    speechText: 'Saya mau tidur',
    speechTextEn: 'I want to go to sleep',
    iconEmoji: '🛏️',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 108,
    categoryId: 1,
    label: 'Minum Obat',
    labelEn: 'Medicine',
    speechText: 'Saya butuh minum obat',
    speechTextEn: 'I need to take my medicine',
    iconEmoji: '💊',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 109,
    categoryId: 1,
    label: 'Cuci Tangan',
    labelEn: 'Wash Hands',
    speechText: 'Saya mau cuci tangan',
    speechTextEn: 'I want to wash my hands',
    iconEmoji: '🧼',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },
  {
    id: 110,
    categoryId: 1,
    label: 'Ganti Baju',
    labelEn: 'Change Clothes',
    speechText: 'Saya ingin ganti baju',
    speechTextEn: 'I want to change my clothes',
    iconEmoji: '👕',
    bgColor: '#FFF7ED',
    borderColor: '#EA580C',
    isDefault: true
  },

  // 2. RESPON (Category 2)
  {
    id: 201,
    categoryId: 2,
    label: 'Ya',
    labelEn: 'Yes',
    speechText: 'Ya',
    speechTextEn: 'Yes',
    iconEmoji: '👍',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 202,
    categoryId: 2,
    label: 'Tidak',
    labelEn: 'No',
    speechText: 'Tidak',
    speechTextEn: 'No',
    iconEmoji: '👎',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 203,
    categoryId: 2,
    label: 'Mau',
    labelEn: 'I Want',
    speechText: 'Saya mau',
    speechTextEn: 'I want this',
    iconEmoji: '👌',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 204,
    categoryId: 2,
    label: 'Tidak Mau',
    labelEn: "Don't Want",
    speechText: 'Saya tidak mau',
    speechTextEn: 'I do not want this',
    iconEmoji: '🙅',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 205,
    categoryId: 2,
    label: 'Terima Kasih',
    labelEn: 'Thank You',
    speechText: 'Terima kasih banyak',
    speechTextEn: 'Thank you very much',
    iconEmoji: '🙏',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 206,
    categoryId: 2,
    label: 'Permisi',
    labelEn: 'Excuse Me',
    speechText: 'Permisi',
    speechTextEn: 'Excuse me',
    iconEmoji: '👋',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 207,
    categoryId: 2,
    label: 'Maaf',
    labelEn: 'Sorry',
    speechText: 'Saya minta maaf',
    speechTextEn: 'I am sorry',
    iconEmoji: '🙇',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 208,
    categoryId: 2,
    label: 'Tolong Ulangi',
    labelEn: 'Repeat Please',
    speechText: 'Tolong ulangi lagi',
    speechTextEn: 'Please repeat that again',
    iconEmoji: '🔄',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 209,
    categoryId: 2,
    label: 'Mengerti',
    labelEn: 'Understood',
    speechText: 'Saya sudah mengerti',
    speechTextEn: 'I understand',
    iconEmoji: '💡',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },
  {
    id: 210,
    categoryId: 2,
    label: 'Tidak Tahu',
    labelEn: "Don't Know",
    speechText: 'Saya tidak tahu',
    speechTextEn: 'I do not know',
    iconEmoji: '🤷',
    bgColor: '#F0FDF4',
    borderColor: '#16A34A',
    isDefault: true
  },

  // 3. PERASAAN (Category 3)
  {
    id: 301,
    categoryId: 3,
    label: 'Senang',
    labelEn: 'Happy',
    speechText: 'Saya merasa senang',
    speechTextEn: 'I feel happy',
    iconEmoji: '😄',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },
  {
    id: 302,
    categoryId: 3,
    label: 'Sedih',
    labelEn: 'Sad',
    speechText: 'Saya merasa sedih',
    speechTextEn: 'I feel sad',
    iconEmoji: '😢',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },
  {
    id: 303,
    categoryId: 3,
    label: 'Marah',
    labelEn: 'Angry',
    speechText: 'Saya sedang marah',
    speechTextEn: 'I feel angry',
    iconEmoji: '😠',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },
  {
    id: 304,
    categoryId: 3,
    label: 'Takut',
    labelEn: 'Scared',
    speechText: 'Saya merasa takut',
    speechTextEn: 'I feel scared',
    iconEmoji: '😨',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },
  {
    id: 305,
    categoryId: 3,
    label: 'Bingung',
    labelEn: 'Confused',
    speechText: 'Saya merasa bingung',
    speechTextEn: 'I feel confused',
    iconEmoji: '😕',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },
  {
    id: 306,
    categoryId: 3,
    label: 'Lelah',
    labelEn: 'Tired',
    speechText: 'Saya merasa lelah sekali',
    speechTextEn: 'I feel very tired',
    iconEmoji: '😫',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },
  {
    id: 307,
    categoryId: 3,
    label: 'Kaget',
    labelEn: 'Surprised',
    speechText: 'Saya kaget',
    speechTextEn: 'I am surprised',
    iconEmoji: '😲',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },
  {
    id: 308,
    categoryId: 3,
    label: 'Cemas',
    labelEn: 'Anxious',
    speechText: 'Saya merasa cemas dan gelisah',
    speechTextEn: 'I feel anxious and uneasy',
    iconEmoji: '😰',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },
  {
    id: 309,
    categoryId: 3,
    label: 'Bangga',
    labelEn: 'Proud',
    speechText: 'Saya bangga',
    speechTextEn: 'I feel proud',
    iconEmoji: '🌟',
    bgColor: '#EFF6FF',
    borderColor: '#2563EB',
    isDefault: true
  },

  // 4. AKTIVITAS & ORANG (Category 4)
  {
    id: 401,
    categoryId: 4,
    label: 'Saya',
    labelEn: 'Me / I',
    speechText: 'Saya',
    speechTextEn: 'Me',
    iconEmoji: '🙋',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 402,
    categoryId: 4,
    label: 'Kamu',
    labelEn: 'You',
    speechText: 'Kamu',
    speechTextEn: 'You',
    iconEmoji: '👉',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 403,
    categoryId: 4,
    label: 'Belajar',
    labelEn: 'Study',
    speechText: 'Saya mau belajar',
    speechTextEn: 'I want to study',
    iconEmoji: '📚',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 404,
    categoryId: 4,
    label: 'Bermain',
    labelEn: 'Play',
    speechText: 'Saya mau bermain',
    speechTextEn: 'I want to play',
    iconEmoji: '⚽',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 405,
    categoryId: 4,
    label: 'Jalan-jalan',
    labelEn: 'Go Outside',
    speechText: 'Mau jalan-jalan keluar',
    speechTextEn: 'I want to go for a walk outside',
    iconEmoji: '🚶',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 406,
    categoryId: 4,
    label: 'Pulang',
    labelEn: 'Go Home',
    speechText: 'Saya mau pulang ke rumah',
    speechTextEn: 'I want to go home',
    iconEmoji: '🏠',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 407,
    categoryId: 4,
    label: 'Ibu',
    labelEn: 'Mom / Mother',
    speechText: 'Ibu',
    speechTextEn: 'Mother',
    iconEmoji: '👩',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 408,
    categoryId: 4,
    label: 'Ayah',
    labelEn: 'Dad / Father',
    speechText: 'Ayah',
    speechTextEn: 'Father',
    iconEmoji: '👨',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 409,
    categoryId: 4,
    label: 'Guru',
    labelEn: 'Teacher',
    speechText: 'Bapak atau Ibu Guru',
    speechTextEn: 'Teacher',
    iconEmoji: '🧑‍🏫',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 410,
    categoryId: 4,
    label: 'Teman',
    labelEn: 'Friend',
    speechText: 'Teman',
    speechTextEn: 'Friend',
    iconEmoji: '🧑‍🤝‍🧑',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  },
  {
    id: 411,
    categoryId: 4,
    label: 'Dokter',
    labelEn: 'Doctor',
    speechText: 'Dokter atau Petugas Medis',
    speechTextEn: 'Doctor or medical staff',
    iconEmoji: '🧑‍⚕️',
    bgColor: '#FAF5FF',
    borderColor: '#9333EA',
    isDefault: true
  }
];
